import { Injectable } from '@angular/core';
import _ from 'lodash';
import { Country } from './_models/country';

@Injectable({ providedIn: 'root' })
export class Globals {
  public StaticOptions = {
    Payment: [
      { id: 1, name: 'Online Payment' },
      { id: 2, name: 'Cash on Delivery' },
    ],
    Delivery: [
      { id: 1, name: 'Ship to my Address' },
      { id: 2, name: 'Pickup at UNO Main Office' },
    ],
    PickupLocations: [
      { id: 1, name: 'UNO West Insula - Quezon City' },
      { id: 2, name: 'UNO Main Office - Cebu' },
      { id: 3, name: 'UNO Main Office - Davao' },
      { id: 4, name: 'UNO Main Office - CDO' },
      { id: 5, name: 'UNO Main Office - Calamba' },
      { id: 6, name: 'UNO Main Office - Baguio' },
      { id: 7, name: 'UNO Main Office - General Santos' },
    ],
    Category: [
      { id: 0, name: 'ALL' },
      { id: 1, name: 'Accessories' },
      { id: 3, name: 'Food and Beverages' },
      { id: 5, name: 'Oral and Skin Care' },
      { id: 6, name: 'Others' },
      { id: 7, name: 'Promotional Items' },
      { id: 9, name: 'Value-added Services' },
      { id: 10, name: 'Vitamins and Supplements' },
      { id: 11, name: 'UNO Cafe Products' },
      { id: 12, name: 'Featured Products' },
    ],
  };
  public countries: Map<number, Country> = new Map();
  public countriesArray: Country[] = [];
  public isMenuOpen = true;

  public goToUrl(router, page) {
    router.navigate([page]);
  }

  public isNullOrEmpty(value): boolean {
    return value == null || !value;
  }

  public menuToggle() {
    this.isMenuOpen = !this.isMenuOpen;
  }
}
